import type { FolderForestNode, FavoritePersonaNode } from "owa-favorites-types";
import { type FolderForestNodeType } from "owa-favorites-types";
import type { FolderForestTreeType } from "owa-graph-schema";

export default function isFolderNodeSelected(selectedNode: FolderForestNode | undefined, folderId: string, treeType: FolderForestTreeType, isVerticalNode: boolean | undefined): boolean {
    if (!selectedNode) {
        return false;
    }
    
    if (isVerticalNode) {
        const selectedFolderId = selectedNode.type === 1
            ? (selectedNode as FavoritePersonaNode).searchFolderId
            : selectedNode.id;
        return folderId === selectedFolderId;
    }
    
    return treeType === selectedNode.treeType && folderId === selectedNode.id;
}
